
class CachedModeDataFetcher {

    constructor(url) {
        this.url = url;
    }

    getData() {
        return fetch(this.url, {credentials: 'include'}).then(res => res.json());
    }
}

export default CachedModeDataFetcher;


// WEBPACK FOOTER //
// ./src/CachedModeDataFetcher.js